import axios from "axios";

export default {
  namespaced: true,
  state: {
    projects: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    projectsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    CLEAR_MARKETPROJECTS(state) {
      state.projects = [];
    },
    RECEIVED_MARKETPROJECTS(state, payload) {
      state.projects = payload;
      state.isReceiving = false;
    },
    RECEIVED_MARKETPROJECT(state, payload) {
      let find = state.projects.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { projects: [payload, ...state.projects] });
      }
      else {
        let index = state.projects.findIndex(x => x._id === payload._id);
        state.projects.splice(index, 1, payload);
      }
    },
    RECEIVING_MARKETPROJECTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_MARKETPROJECT(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETPROJECT(state, payload) {
      let index = state.projects.findIndex(project => project._id === payload._id);
      state = Object.assign(state, {
        projects: state.projects.map((project, i) => {
          if (i === index) {
            return Object.assign({}, project, payload);
          }
          return project;
        }),
        isUpdating: false,
        projectsMessage: 'MarketProjects has been updating!',
      })
    },
    UPDATING_MARKETPROJECT(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETPROJECT(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.projects.findIndex(project => project._id === payload._id);
      console.log(indexToDelete);
      let projects = [...state.projects];
      projects.splice(indexToDelete, 1);
      state = Object.assign(state, {
        projects: [...projects],
        isDeleting: false,
        idToDelete: null,
        projectsMessage: 'MarketProject has been Deleted!',
      });
    },
    DELETING_MARKETPROJECT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketProjectRequest({dispatch}, payload) {
      dispatch("deletingMarketProject", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/marketproject/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteMarketProject", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async insertMarketProjectRequest({dispatch}, payload) {
      dispatch("receivingMarketProjects");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/marketproject';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketProject", response.data);
      return response.data;
    },
    async insertMarketProjectWithImageRequest({dispatch}, payload) {
      console.log(payload)
      dispatch("receivingMarketProjects");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/marketproject/withimage';
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        console.log(response)
        dispatch("receiveMarketProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertProjectCampaignRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/adcampaign/' + payload.projectid;
        console.log(url)
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketProjectRequest({dispatch}, id) {
      dispatch("receivingMarketProjects");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/marketproject/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveMarketProject", response.data);
      return response.data;
    },
    async getMarketProjectsRequest({dispatch}) {
      dispatch("receivingMarketProjects");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/marketprojects';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveMarketProjects", response.data);
      })
    },
    async getMarketProjectsTeamRequest({dispatch}) {
      dispatch("receivingMarketProjects");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/get/marketprojects/team';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveMarketProjects", response.data);
      })
    },
    async getMarketProjectsAllRequest({dispatch}) {
      try{
        dispatch("receivingMarketProjects");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/marketprojects/all';
        let response = await axios({method: "get", url: url, headers: headers});
        dispatch("receiveMarketProjects", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketProjectQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketProjects");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/projects/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveMarketProjects", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketProjectRequest({dispatch}, payload) {
      dispatch("updatingMarketProject");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/marketproject/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method: "put", url: url, headers: headers, data: payload})
      dispatch("updateMarketProject", response.data);
      return response.data;
    },
    async updateMarketProjectImageRequest({dispatch}, payload) {
      dispatch("updatingMarketProject");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/marketproject/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateMarketProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateProjectCampaignRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/adcampaign/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        console.log(response.data)
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    clearMarketProjects({commit}) {
      commit("CLEAR_MARKETPROJECTS")
    },
    receiveMarketProjects({commit}, payload) {
      commit("RECEIVED_MARKETPROJECTS", payload)
    },
    receiveMarketProject({commit}, payload) {
      commit("RECEIVED_MARKETPROJECT", payload)
    },
    receivingMarketProjects({commit}) {
      commit("RECEIVING_MARKETPROJECTS")
    },
    receivingMarketProject({commit}) {
      commit("RECEIVING_MARKETPROJECT")
    },
    updateMarketProject({commit}, payload) {
      commit("UPDATED_MARKETPROJECT", payload)
    },
    updatingMarketProject({commit}) {
      commit("UPDATING_MARKETPROJECT")
    },
    deleteMarketProject({commit}, payload) {
      commit("DELETED_MARKETPROJECT", payload)
    },
    deletingMarketProject({commit}, payload) {
      commit("DELETING_MARKETPROJECT", payload)
    }
  },
};
